import { jsx as _jsx } from "react/jsx-runtime";
import { MenuItem } from '@mui/material';
import { ENG_MONTHS } from '@iotv/datamodel-core';
const thirtyOnes = [0, 2, 4, 6, 8, 10, 12];
const thirties = [3, 5, 7, 9, 11];
const feb = 1;
const getDaysInMonth = (year, month) => {
    const isLeap = year % 4 !== 0;
    if (thirtyOnes.includes(month)) {
        return 31;
    }
    else if (thirties.includes(month)) {
        return 30;
    }
    else {
        if (isLeap) {
            return 29;
        }
        else
            return 28;
    }
};
export const getYears = (year, minus, plus) => {
    const arr = new Array(minus + plus + 1).fill(0);
    return arr.reduce((acc, curr, i) => {
        acc[i] = year - minus + i;
        return acc;
    }, arr);
};
export const getDays = (year, month) => {
    const numDays = getDaysInMonth(year, month);
    const arr = new Array(numDays).fill(0);
    return arr.reduce((acc, curr, i) => {
        acc[i] = i + 1;
        return acc;
    }, arr);
};
export const getHours = () => {
    const arr = new Array(24).fill(0);
    return arr.reduce((acc, curr, i) => {
        acc[i] = i;
        return acc;
    }, arr);
};
export const getMinutes = () => {
    const arr = new Array(60).fill(0);
    return arr.reduce((acc, curr, i) => {
        acc[i] = i;
        return acc;
    }, arr);
};
export const getYearInputMenuItems = (cur, minus, plus) => {
    const years = getYears(cur, minus, plus);
    return years.map((year) => (_jsx(MenuItem, { value: year, children: year }, year)));
};
export const getMonthInputMenuItems = () => {
    const monthsEntries = Object.entries(ENG_MONTHS).filter(([k, v]) => typeof v !== 'number');
    return monthsEntries.map(([x, y]) => (_jsx(MenuItem, { value: y, children: y }, x)));
};
export const getDayInputMenuItems = (year, month) => {
    const days = getDays(year, month);
    return days.map((day) => (_jsx(MenuItem, { value: day, children: day }, day)));
};
export const getHoursInputMenuItems = () => {
    const hours = getHours();
    return hours.map((hr) => (_jsx(MenuItem, { value: hr, children: hr }, hr)));
};
export const getMinutesInputMenuItems = () => {
    const minutes = getMinutes();
    return minutes.map((min) => (_jsx(MenuItem, { value: min, children: min }, min)));
};
